<ngx-extended-pdf-viewer
  [src]="document ? document : documentUrl"
  height="90vh"
  useBrowserLocale="true"
  [showSpreadButton]="false"
  [showPresentationModeButton]="false"
  [showDownloadButton]="false"
  [showOpenFileButton]="false"
  [showScrollingButton]="false"
  [showBookmarkButton]="false"
  [showSidebarButton]="false"
  [showPrintButton]="false"
  theme="dark"
  [handTool]="false"
  (pdfLoaded)="pdfLoaded()"
></ngx-extended-pdf-viewer>
